import CategoryModel from "../sdk/CategoryModel"

export default class CategoryModelCustom extends CategoryModel {
}



// WEBPACK FOOTER //
// ./src/shop/CategoryModel.js